export function organizationAuctionReducer(
  state = {
    organization: {},
    loadings: false,
    uploadLoading: false
  },
  { type, payload }
) {
  switch (type) {
    case "GET_ORAGANIZATION_AUCTION":
      return { ...state, organization: payload };
    case "HIDE_LOADING_ORAGANIZATION":
      return { ...state, loadings: false };
    case "SHOW_LOADING_ORAGANIZATION":
      return { ...state, loadings: true };
      case "HIDE_UPLOAD_ORAGANIZATION":
        return { ...state, uploadLoading: false };
      case "SHOW_UPLOAD_ORAGANIZATION":
        return { ...state, uploadLoading: true };
  
    default:
      return state;
  }
}
